import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import {
  FaClipboardList, FaShieldHalved, FaListCheck,
  FaPhoneVolume, FaMountainSun, FaCampground, FaPeopleGroup,
} from "react-icons/fa6";
import "./ApplyTheJourney.css";

const ease = [0.22, 1, 0.36, 1];
const fadeUp = (d = 0) => ({ hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0, transition: { duration: 0.6, ease, delay: d } } });

const STEPS = [
  { num:"01", Icon: FaClipboardList,  bg:"#4a5e42", label:"Register",           desc:"Create your account and verify your service."          },
  { num:"02", Icon: FaShieldHalved,   bg:"#a86642", label:"Verification",        desc:"We verify your documents and confirm eligibility."      },
  { num:"03", Icon: FaListCheck,      bg:"#4a5e42", label:"Application Review",  desc:"Our team reviews your application carefully."           },
  { num:"04", Icon: FaPhoneVolume,    bg:"#a86642", label:"Confirmation Call",   desc:"A team member will call to get to know you."           },
  { num:"05", Icon: FaMountainSun,    bg:"#4a5e42", label:"Preparation",         desc:"We help you prepare for the retreat."                  },
  { num:"06", Icon: FaCampground,     bg:"#4a5e42", label:"Retreat",             desc:"Experience healing, growth, and brotherhood."          },
  { num:"07", Icon: FaPeopleGroup,    bg:"#4a5e42", label:"Alumni Community",    desc:"Lifelong support through our alumni network."          },
];

export default function ApplyTheJourney() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });

  return (
    <section className="atj" ref={ref}>
      <div className="container-fg container-2xxl">

        <motion.div className="atj__header" variants={fadeUp(0)} initial="hidden" animate={inView ? "show" : "hidden"}>
          <span className="atj__rule" aria-hidden="true" />
          <h2 className="atj__heading u-eyebrow">The Journey</h2>
          <span className="atj__rule" aria-hidden="true" />
        </motion.div>

        <div className="atj__steps">
          {STEPS.map((s, i) => (
            <div key={s.num} className="atj__group">
              <motion.div className="atj__step"
                variants={fadeUp(0.05 + i * 0.07)} initial="hidden" animate={inView ? "show" : "hidden"}>
                <div className="atj__circle" style={{ background: s.bg }} aria-hidden="true">
                  <s.Icon />
                </div>
                <div className="atj__step-text">
                  <span className="atj__num">{s.num}</span>
                  <h3 className="atj__label">{s.label.toUpperCase()}</h3>
                  <p className="atj__desc">{s.desc}</p>
                </div>
              </motion.div>

              {i < STEPS.length - 1 && (
                <motion.span className="atj__dash" aria-hidden="true"
                  variants={fadeUp(0.09 + i * 0.07)} initial="hidden" animate={inView ? "show" : "hidden"} />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
